export enum HelperTypeEnum {
    INFO = 'info',
    WARNING = 'warning',
    DANGER= 'danger'
}